import load from 'load-script';

const loadScript = (src, options = {}) => new Promise((resolve, reject) => {
  load(src, options, (error, script) => (error ? reject(error) : resolve(script)));
});

export default loadScript;
